{
    "banner": {
        "title": "Chúng tôi sử dụng cookie",
        "message": "Chúng tôi sử dụng cookie để cải thiện trải nghiệm của bạn và phân tích lưu lượng truy cập. Bạn có thể chấp nhận tất cả hoặc chỉ giữ cookie cần thiết.",
        "acceptAll": "Chấp nhận tất cả",
        "rejectOptional": "Chỉ cookie cần thiết",
        "preferences": "Quản lý tùy chọn",
        "essentialNote": "Cookie cần thiết luôn được bật để hệ thống hoạt động (đăng nhập, bảo mật, ngôn ngữ)."
    },
    "preferences": {
        "title": "Tùy chọn cookie",
        "essential": "Cookie cần thiết (luôn bật)",
        "analytics": "Cookie phân tích",
        "marketing": "Cookie tiếp thị",
        "save": "Lưu tùy chọn"
    }
}
